<template>
  <add-edit-dialog>
    <div class="page-title">修正客户</div>
    <div class="page-add-custom">
      <custom-form
        :customerUid="row.uid"
        :customDetail="customDetail"
        @submit="customFormSubmit"
        @close="closeCustomSubmit">
          <el-form-item label="审核备注：">
            <el-col :span="11">
              <el-input
                disabled
                type="textarea"
                :rows="4"
                v-model="customDetail.commonCustomer.remark">
              </el-input>
            </el-col>
          </el-form-item>
        </custom-form>
    </div>
  </add-edit-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CustomForm from '~component/business/custom/customForm.vue';
import AddEditDialog from '@/components/base/addEditDialog';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';

export default {
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
    CustomForm,
  },
  props: {
    row: Object,
  },
  computed: {
    ...mapGetters({
      customDetail: 'customer/customDetail',
    }),
  },
  created() {
    this.getCustomDetail({
      uid: this.row.uid,
      type: this.row.type,
    }).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions({
      getCustomDetail: 'customer/getCustomDetail',
      correctionCustom: 'customer/correctionCustom',
    }),
    customFormSubmit(params) {
      this.correctionCustom(params).then(() => {
        this.$message({
          message: '客户信息修正成功',
          type: 'success',
        });
        this.$emit('closeCorrectionCustom');
      });
    },
    closeCustomSubmit() {
      this.$emit('closeCorrectionCustom');
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';
@import '~@/styles/const.less';

.page-title {
  height: 33px;
  margin-bottom: 10px;
  font-size: @font-size--max;
  color: @color--info;
  line-height: 33px;
  line-height: 33px;
}
.page-add-custom {
  overflow: auto;
  .add-custom-form {
    padding-left: 100px;
  }
}
</style>
